import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

function Main() {
  const [active, setActive] = useState();
  const [show, setShow] = useState();
  const [menu, setMenu] = useState();
  const [page, setPage] = useState();
  const [drop, setDrop] = useState();
  const [lastscrool, setlastscrool] = useState(0);

  const [scrolled, setScrolled] = useState(false);
  const [Nav, setNav] = useState(true);

  const handleScroll = () => {
    const offset = window.scrollY;
    setlastscrool(offset);

    if (offset > 1000 && offset < lastscrool) {
      setNav(true);
      setScrolled(true);
    } else if (offset > 1000) {
      setNav(false);
    } else if (offset > 200) {
      setNav(true);
      setScrolled(true);
    } else {
      setScrolled(false);
      setNav(true);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
  });

  return (
    <>
      {active && (
        <div
          className="menu-backdrop"
          style={{ opacity: "1", visibility: "visible" }}
          onClick={() => setActive(false)}
        ></div>
      )}
      <section
        className={`hidden-bar ${active && "visible-sidebar"}`}
        onClick={() => setActive(false)}
      >
        <div className="inner-box">
          <div
            className="cross-icon hidden-bar-closer"
            onClick={() => setActive(false)}
          >
            <span className="far fa-close"> </span>
          </div>
          <div className="logo-box">
            <Link to="/">
              <span style={{ fontWeight: 900, fontSize: "36px" }}>X-GROUP</span>
            </Link>
          </div>

          <div className="side-menu">
            <ul className="navigation clearfix">
              <li className="current">
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/menu">Menus</Link>
              </li>
              <li>
                <Link to="/sister-concern">Sister Concern</Link>
              </li>
              <li>
                <Link to="/managements">Management</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </div>

          <h2>Visit Us</h2>
          <ul className="info">
            <li>
              <i class="icon far fa-map-marker-alt"></i> House No. 59/A, Sheikh
              Kamal Saroni Sat Masjid Road, Dhanmondi, Dhaka-1209.
            </li>
            <li>
              <i class="icon far fa-clock"></i> Lunch: 12:00 pm - 3:00 pm,
              Dinner: 6:00 pm - 10:30 pm
            </li>
            <li>
              <Link to="mailto:admin@x-grouprestaurant.com">
                admin@x-grouprestaurant.com
              </Link>
            </li>
          </ul>
          <div className="separator">
            <span></span>
          </div>
          <div className="booking-info">
            <div className="bk-title">Booking request</div>
            <div className="bk-no">
              <Link to="tel:01755636335">01755636335</Link>
            </div>
          </div>
        </div>
      </section>

      {Nav && (
        <header
          className={`main-header ${scrolled && "fixed-header"} header-down`}
        >
          <div className="header-top">
            <div className="auto-container">
              <div className="inner clearfix">
                <div className="top-left clearfix">
                  <ul className="top-info clearfix">
                    <li>
                      <i class="icon far fa-map-marker-alt"></i> House No. 59/A,
                      Sheikh Kamal Saroni Sat Masjid Road, Dhanmondi,
                      Dhaka-1209.
                    </li>
                    <li>
                      <i class="icon far fa-clock"></i> Lunch: 12:00 pm - 3:00
                      pm, Dinner: 6:00 pm - 10:30 pm
                    </li>
                  </ul>
                </div>
                <div className="top-right clearfix">
                  <ul className="top-info clearfix">
                    <li>
                      <Link to="tel:+8801755636335">
                        <i class="icon far fa-phone"></i> 01755636335
                      </Link>
                    </li>
                    <li>
                      <Link href="mailto:booking@restaurant.com">
                        <i class="icon far fa-envelope"></i>
                        admin@x-grouprestaurant.com
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="header-upper">
            <div className="auto-container">
              <div className="main-box clearfix">
                <div className="logo-boxtwo">
                  <div className="logo">
                    <Link to="/">
                      <span style={{ fontWeight: 900, fontSize: "36px" }}>
                        X-GROUP
                      </span>
                    </Link>
                  </div>
                </div>

                <div className="nav-boxtwo clearfix">
                  <div className="nav-outertwo clearfix">
                    <nav className="main-menu">
                      <ul className="navigation clearfix">
                        <li class="current">
                          <Link to="/">Home</Link>
                        </li>
                        <li>
                          <Link to="/about">About Us</Link>
                        </li>
                        <li>
                          <Link to="/menu">Menus</Link>
                        </li>
                        <li>
                          <Link to="/sister-concern">Sister Concern</Link>
                        </li>
                        <li>
                          <Link to="/managements">Management</Link>
                        </li>
                        <li>
                          <Link to="/contact">Contact</Link>
                        </li>
                      </ul>
                    </nav>
                  </div>

                  <div className="links-boxtwo">
                    <div className="link link-btn">
                      <Link
                        to="/reservation"
                        className="theme-btn btn-style-one clearfix"
                      >
                        <span className="btn-wrap">
                          <span className="text-one">find a table</span>
                          <span className="text-two">find a table</span>
                        </span>
                      </Link>
                    </div>
                    <div className="link info-toggler">
                      <button
                        className="info-btn"
                        onClick={() => setActive(true)}
                        style={{ background: "transparent" }}
                      >
                        <span className="hamburger">
                          <span className="top-bun"></span>
                          <span className="meat"></span>
                          <span className="bottom-bun"></span>
                        </span>
                      </button>
                    </div>
                  </div>

                  <div className="nav-togglertwo">
                    <button
                      className="hidden-bar-opener"
                      onClick={() => setActive(true)}
                      style={{ background: "transparent" }}
                    >
                      <span className="hamburger">
                        <span className="top-bun"></span>
                        <span className="meat"></span>
                        <span className="bottom-bun"></span>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
      )}
    </>
  );
}

export default Main;
